import {Utilities} from '../utilities/utilities.model';

export class CountriesListModel {
	static countries: any[] = [
		{code: 'A', name: 'AUSTRIA'},
		{code: 'ABU', name: 'EMIRATO DI ABU-DHABI'},
		{code: 'ADN', name: 'YEMEN'},
		{code: 'AFG', name: 'AFGHANISTAN'},
		{code: 'AG', name: 'ANTIGUA E BVARBUDA'},
		{code: 'AI', name: 'ANGUILLA'},
		{code: 'AJ', name: 'AZERBAIJAN'},
		{code: 'AL', name: 'ALBANIA'},
		{code: 'AND', name: 'ANDORRA'},
		{code: 'AQ', name: 'ANTARTIDE'},
		{code: 'ARM', name: 'ARMENIA'},
		{code: 'AS', name: 'SAMOA AMERICANE'},
		{code: 'AUS', name: 'AUSTRALIA'},
		{code: 'AW', name: 'ARUBA'},
		{code: 'AX', name: 'ISOLE ALAND'},
		{code: 'B', name: 'BELGIO'},
		{code: 'BD', name: 'BANGLADESH'},
		{code: 'BDS', name: 'BARBADOS'},
		{code: 'BEL', name: 'BIELORUSSIA'},
		{code: 'BG', name: 'BULGARIA'},
		{code: 'BH', name: 'HONDURAS BRITANNICO'},
		{code: 'BIH', name: 'BOSNIA-ERZEGOVINA'},
		{code: 'BL', name: 'BASUTOLAND'},
		{code: 'BO', name: 'BIELORUSSIA'},
		{code: 'BOS', name: 'BOSNIA - ERZEGOVINA'},
		{code: 'BP', name: 'BOTSWANA'},
		{code: 'BR', name: 'BRASILE'},
		{code: 'BRG', name: 'GUIANA BRITANNICA'},
		{code: 'BRM', name: 'ISOLE BERMUDA'},
		{code: 'BRN', name: 'BAHREIN'},
		{code: 'BRU', name: 'BRUNEI'},
		{code: 'BS', name: 'BAHAMA'},
		{code: 'BTN', name: 'BHUTAN'},
		{code: 'BUR', name: 'BIRMANIA'},
		{code: 'BV', name: 'ISOLA DI BOUVET'},
		{code: 'BZ', name: 'BELIZE'},
		{code: 'C', name: 'CUBA'},
		{code: 'CC', name: 'ISOLE DI COCOS (KEELING)'},
		{code: 'CDN', name: 'CANADA'},
		{code: 'CH', name: 'SVIZZERA'},
		{code: 'CI', name: 'COSTA DI AVORIO'},
		{code: 'CK', name: 'REPUBBLICA CECA'},
		{code: 'CL', name: 'CEYLON'},
		{code: 'CNB', name: 'BORNEO DEL NORD'},
		{code: 'CO', name: 'COLOMBIA'},
		{code: 'COD', name: 'REPUBBLICA DEMOCRATICA DEL CONGO'},
		{code: 'COK', name: 'ISOLE DI CUOCO'},
		{code: 'CR', name: 'COSTA RICA'},
		{code: 'CRO', name: 'CROAZIA'},
		{code: 'CS', name: 'CECOSLOVACCHIA'},
		{code: 'CSI', name: 'RUSSIA'},
		{code: 'CV', name: 'ISOLA DI CAPO VERDE'},
		{code: 'CX', name: 'CHRISTMAS ISLAND'},
		{code: 'D', name: 'GERMANIA'},
		{code: 'DDR', name: 'REPUBBLICA DEMOCRATICA DI GERMANIA'},
		{code: 'DJ', name: 'GIBUTI'},
		{code: 'DK', name: 'DANIMARCA'},
		{code: 'DM', name: 'DOMINICA'},
		{code: 'DY', name: 'DAHOMEY'},
		{code: 'DZ', name: 'ALGERIA'},
		{code: 'E', name: 'SPAGNA'},
		{code: 'EAK', name: 'KENYA'},
		{code: 'EAT', name: 'TANZANIA'},
		{code: 'EAU', name: 'UGANDA'},
		{code: 'EC', name: 'ECUADOR'},
		{code: 'EE', name: 'COMUNE TERRITORIO CEDUTO'},
		{code: 'EH', name: 'SAHARA OCCIDENTALE'},
		{code: 'EIR', name: 'IRLANDA'},
		{code: 'ER', name: 'ERITREA'},
		{code: 'EST', name: 'ESTONIA'},
		{code: 'ET', name: 'EGITTO'},
		{code: 'ETH', name: 'ETIOPIA'},
		{code: 'F', name: 'FRANCIA'},
		{code: 'FI', name: 'FILIPPINE'},
		{code: 'FK', name: 'ISOLE FALKLAND (O MALVINE)'},
		{code: 'FL', name: 'LIECHTENSTEIN'},
		{code: 'FM', name: 'MICRONESIA, STATI FEDERATI'},
		{code: 'FO', name: 'ISOLE DI FAROE'},
		{code: 'G', name: 'GUATEMALA'},
		{code: 'GAB', name: 'REP. DEL GABON'},
		{code: 'GB', name: 'GRAN BRETAGNA'},
		{code: 'GBG', name: 'ISOLA GUERNSEY'},
		{code: 'GBJ', name: 'ISOLA DI JERSEY'},
		{code: 'GBM', name: 'ISOLA DI MAN'},
		{code: 'GBY', name: 'ISOLA DI MALTA'},
		{code: 'GBZ', name: 'GIBILTERRA'},
		{code: 'GD', name: 'GRENADA'},
		{code: 'GEO', name: 'GEORGIA'},
		{code: 'GF', name: 'GUAYANA'},
		{code: 'GH', name: 'GHANA'},
		{code: 'GL', name: 'GROENLANDIA'},
		{code: 'GP', name: 'GUADALUPA'},
		{code: 'GQ', name: 'GUINEA EQUATORIALE'},
		{code: 'GR', name: 'GRECIA'},
		{code: 'GS', name: 'GEORGIA DEL SUD E IS. SANDWICH'},
		{code: 'GU', name: 'GUAM'},
		{code: 'GUB', name: 'GUINEA BISSAU'},
		{code: 'GV', name: 'GUINEA'},
		{code: 'GY', name: 'GUYANA'},
		{code: 'H', name: 'UNGHERIA'},
		{code: 'HK', name: 'HONG-KONG'},
		{code: 'HN', name: 'HONDURAS'},
		{code: 'HV', name: 'ALTO VOLTA'},
		{code: 'I', name: 'ITALIA'},
		{code: 'IL', name: 'ISRAELE'},
		{code: 'IND', name: 'INDIA'},
		{code: 'IO', name: 'TERRITORIO BRITANNICO DELL\'OCEANO INDIANO'},
		{code: 'IR', name: 'IRAN'},
		{code: 'IRQ', name: 'IRAQ'},
		{code: 'IS', name: 'ISLANDA'},
		{code: 'J', name: 'GIAPPONE'},
		{code: 'JA', name: 'GIAMAICA'},
		{code: 'JOR', name: 'GIORDANIA'},
		{code: 'K', name: 'CAMBOGIA'},
		{code: 'KG', name: 'KYRGYZSTAN'},
		{code: 'KI', name: 'KIRIBATI'},
		{code: 'KL', name: 'LIBIA'},
		{code: 'KM', name: 'COMORE'},
		{code: 'KN', name: 'SAN KITTS AND NEVIS'},
		{code: 'KP', name: 'KOREA DEL NORD'},
		{code: 'KS', name: 'KOSOVO'},
		{code: 'KWT', name: 'KUWAIT'},
		{code: 'KY', name: 'ISOLE CAYMAN'},
		{code: 'KZ', name: 'KAZACHISTAN'},
		{code: 'L', name: 'LUSSEMBURGO'},
		{code: 'LAO', name: 'LAOS'},
		{code: 'LC', name: 'SAN LUCIA'},
		{code: 'LET', name: 'LETTONIA'},
		{code: 'LIB', name: 'LIBERIA'},
		{code: 'LIT', name: 'LITUANIA'},
		{code: 'LS', name: 'LESOTO'},
		{code: 'M', name: 'MALTA'},
		{code: 'MA', name: 'MAROCCO'},
		{code: 'MAC', name: 'MACEDONIA'},
		{code: 'MAU', name: 'MAURITANIA'},
		{code: 'MC', name: 'MONACO'},
		{code: 'MD', name: 'MOLDAVIA'},
		{code: 'MDG', name: 'MADAGASCAR'},
		{code: 'MEX', name: 'MESSICO'},
		{code: 'MH', name: 'ISOLE DI MARSHALL'},
		{code: 'MNE', name: 'MONTENEGRO'},
		{code: 'MNG', name: 'MONGOLIA'},
		{code: 'MO', name: 'MACAO'},
		{code: 'MOC', name: 'MOZAMBICO'},
		{code: 'MOL', name: 'MOLDOVA'},
		{code: 'MP', name: 'ISOLE DI MARIANA DEL NORD'},
		{code: 'MQ', name: 'MARTINICA'},
		{code: 'MS', name: 'MAURIZIO'},
		{code: 'MST', name: 'MONTSERRAT'},
		{code: 'N', name: 'NORVEGIA'},
		{code: 'NA', name: 'ANTILLE OLANDESI'},
		{code: 'NAM', name: 'NAMIBIA'},
		{code: 'NC', name: 'NUOVA CALEDONIA'},
		{code: 'NEP', name: 'NEPAL'},
		{code: 'NF', name: 'ISOLA DELLA NORFOLK'},
		{code: 'NIC', name: 'NICARAGUA'},
		{code: 'NIG', name: 'NIGER'},
		{code: 'NL', name: 'OLANDA'},
		{code: 'NR', name: 'NAURU'},
		{code: 'NU', name: 'NIUE'},
		{code: 'NZ', name: 'NUOVA ZELANDA'},
		{code: 'P', name: 'PORTOGALLO'},
		{code: 'PA', name: 'PANAMA'},
		{code: 'PAK', name: 'PAKISTAN'},
		{code: 'PAN', name: 'ANGOLA'},
		{code: 'PE', name: 'PERU'},
		{code: 'PF', name: 'POLYNESIA FRANCESE'},
		{code: 'PG', name: 'PAPUA NUOVA GUINEA'},
		{code: 'PL', name: 'POLONIA'},
		{code: 'PM', name: 'SAN PIERRE E MICHELON'},
		{code: 'PN', name: 'ISOLE DI PITCAIRN'},
		{code: 'PR', name: 'PORTORICO'},
		{code: 'PS', name: 'PALESTINA'},
		{code: 'PTM', name: 'MALAYSIA'},
		{code: 'PW', name: 'PALAU'},
		{code: 'PY', name: 'PARAGUAY'},
		{code: 'QAT', name: 'QATAR'},
		{code: 'R', name: 'ROMANIA'},
		{code: 'RA', name: 'ARGENTINA'},
		{code: 'RB', name: 'BOLIVIA'},
		{code: 'RBE', name: 'REPUBBLICA DEL BENIN'},
		{code: 'RC', name: 'CINA'},
		{code: 'RCA', name: 'REP. CENTRO AFRICANA'},
		{code: 'RCB', name: 'CONGO OVEST'},
		{code: 'RCF', name: 'FORMOSA'},
		{code: 'RCH', name: 'CILE'},
		{code: 'RCL', name: 'CONGO EST'},
		{code: 'RD', name: 'DOMINICANA REPUBBLICA'},
		{code: 'RE', name: 'ISOLE DELLA RIUNIONE'},
		{code: 'RFR', name: 'REPUBBLICA FEDERATIVA RUSSA'},
		{code: 'RH', name: 'HAITI'},
		{code: 'RI', name: 'INDONESIA'},
		{code: 'RL', name: 'LIBANO'},
		{code: 'RM', name: 'REP. MALGASCIA'},
		{code: 'RMA', name: 'REPUBBLICA DELLE MALDIVE'},
		{code: 'RMM', name: 'MALI'},
		{code: 'RNR', name: 'ZAMBIA'},
		{code: 'RNY', name: 'MALAWI'},
		{code: 'ROK', name: 'KOREA DEL SUD'},
		{code: 'RSA', name: 'REPUBBLICA DI SUDAFRICA'},
		{code: 'RSM', name: 'SAN MARINO'},
		{code: 'RSR', name: 'RHODESIA DEL SUD'},
		{code: 'RU', name: 'BURUNDI'},
		{code: 'RWA', name: 'RUANDA'},
		{code: 'RY', name: 'CIPRO'},
		{code: 'S', name: 'SVEZIA'},
		{code: 'SA', name: 'ARABIA SAUDITA'},
		{code: 'SAL', name: 'EL SALVADOR'},
		{code: 'SB', name: 'SALOMONE'},
		{code: 'SCV', name: 'VATICANO'},
		{code: 'SD', name: 'SWAZILAND'},
		{code: 'SER', name: 'SERBIA E MONTENEGRO'},
		{code: 'SF', name: 'FINLANDIA'},
		{code: 'SGP', name: 'SINGAPORE'},
		{code: 'SH', name: 'SAN HELENA'},
		{code: 'SJ', name: 'SVALBARD E LE ISOLE GENNAIO'},
		{code: 'SLK', name: 'SRI LANKA'},
		{code: 'SLO', name: 'SLOVENIA'},
		{code: 'SLV', name: 'SLOVACCHIA'},
		{code: 'SME', name: 'SURINAME'},
		{code: 'SN', name: 'SENEGAL'},
		{code: 'SOM', name: 'SOMALIA'},
		{code: 'SRB', name: 'SERBIA'},
		{code: 'ST', name: 'SAO TOME E PRINCIPE'},
		{code: 'SU', name: 'URSS'},
		{code: 'SUD', name: 'SUDAN'},
		{code: 'SWA', name: 'AFRICA DEL SUDOVEST'},
		{code: 'SY', name: 'SEYCHELLES'},
		{code: 'SYR', name: 'SIRIA'},
		{code: 'T', name: 'TAILANDIA'},
		{code: 'TC', name: 'CAMERUN'},
		{code: 'TCH', name: 'CIAD'},
		{code: 'TCI', name: 'TURCHIA E ISOLE DEL CAICOS'},
		{code: 'TF', name: 'TERRITORI DEL SUD FRANCESI'},
		{code: 'TG', name: 'TOGO'},
		{code: 'TJ', name: 'TAJIKISTAN'},
		{code: 'TK', name: 'TOKELAU'},
		{code: 'TL', name: 'TIMOR-LESTE'},
		{code: 'TM', name: 'TURKMENISTAN'},
		{code: 'TN', name: 'TUNISIA'},
		{code: 'TO', name: 'TONGA'},
		{code: 'TR', name: 'TURCHIA'},
		{code: 'TT', name: 'TRINIDAD E TOBAGO'},
		{code: 'TV', name: 'TUVALU'},
		{code: 'TWA', name: 'TAIWAN'},
		{code: 'U', name: 'URUGUAY'},
		{code: 'UAE', name: 'EMIRATI ARABI UNITI'},
		{code: 'UCR', name: 'UCRAINA'},
		{code: 'UK', name: 'REGNO UNITO'},
		{code: 'UM', name: 'ISOLE AMERICANE DEL PACIFICO'},
		{code: 'USA', name: 'STATI UNITI AMERICA'},
		{code: 'UV', name: 'BURKINA FASO'},
		{code: 'UZ', name: 'UZBEKISTAN'},
		{code: 'VC', name: 'SAN VINCENT E IL GRENADINES'},
		{code: 'VG', name: 'ISOLE VERGINI BRITANNICHE'},
		{code: 'VI', name: 'ISOLE VERGINI'},
		{code: 'VN', name: 'VIETNAM'},
		{code: 'VU', name: 'VANUATU'},
		{code: 'WAG', name: 'GAMBIA'},
		{code: 'WAL', name: 'SIERRA LEONE'},
		{code: 'WAN', name: 'NIGERIA'},
		{code: 'WF', name: 'WALLIS E FUTUNA'},
		{code: 'WS', name: 'SAMOA'},
		{code: 'YT', name: 'MAYOTTE'},
		{code: 'YU', name: 'JUGOSLAVIA'},
		{code: 'YV', name: 'VENEZUELA'},
		{code: 'ZA', name: 'SUD AFRICA'},
		{code: 'ZI', name: 'ZIMBABWE'},
		{code: 'ZRE', name: 'ZAIRE'}
	];

	static isoCountries = [
		{code: 'IT', name: 'ITALIA'},
		{code: 'AF', name: 'AFGHANISTAN'},
		{code: 'AL', name: 'ALBANIA'},
		{code: 'DZ', name: 'ALGERIA'},
		{code: 'AD', name: 'ANDORRA'},
		{code: 'AO', name: 'ANGOLA'},
		{code: 'AI', name: 'ANGUILLA'},
		{code: 'AQ', name: 'ANTARTIDE'},
		{code: 'AG', name: 'ANTIGUA E BARBUDA'},
		{code: 'SA', name: 'ARABIA SAUDITA'},
		{code: 'AR', name: 'ARGENTINA'},
		{code: 'AM', name: 'ARMENIA'},
		{code: 'AW', name: 'ARUBA'},
		{code: 'AU', name: 'AUSTRALIA'},
		{code: 'AT', name: 'AUSTRIA'},
		{code: 'AZ', name: 'AZERBAIGIAN'},
		{code: 'BS', name: 'BAHAMAS'},
		{code: 'BH', name: 'BAHREIN'},
		{code: 'BD', name: 'BANGLADESH'},
		{code: 'BB', name: 'BARBADOS'},
		{code: 'BE', name: 'BELGIO'},
		{code: 'BZ', name: 'BELIZE'},
		{code: 'BJ', name: 'BENIN'},
		{code: 'BM', name: 'BERMUDA'},
		{code: 'BT', name: 'BHUTAN'},
		{code: 'BY', name: 'BIELORUSSIA'},
		{code: 'MM', name: 'BIRMANIA'},
		{code: 'BO', name: 'BOLIVIA'},
		{code: 'BA', name: 'BOSNIA ED ERZEGOVINA'},
		{code: 'BW', name: 'BOTSWANA'},
		{code: 'BR', name: 'BRASILE'},
		{code: 'BN', name: 'BRUNEI'},
		{code: 'BG', name: 'BULGARIA'},
		{code: 'BF', name: 'BURKINA FASO'},
		{code: 'BI', name: 'BURUNDI'},
		{code: 'KH', name: 'CAMBOGIA'},
		{code: 'CM', name: 'CAMERUN'},
		{code: 'CA', name: 'CANADA'},
		{code: 'CV', name: 'CAPO VERDE'},
		{code: 'TD', name: 'CIAD'},
		{code: 'CL', name: 'CILE'},
		{code: 'CN', name: 'CINA'},
		{code: 'CY', name: 'CIPRO'},
		{code: 'VA', name: 'CITTÀ DEL VATICANO'},
		{code: 'CO', name: 'COLOMBIA'},
		{code: 'KM', name: 'COMORE'},
		{code: 'KP', name: 'COREA DEL NORD'},
		{code: 'KR', name: 'COREA DEL SUD'},
		{code: 'CI', name: 'COSTA D\'AVORIO'},
		{code: 'CR', name: 'COSTA RICA'},
		{code: 'HR', name: 'CROAZIA'},
		{code: 'CU', name: 'CUBA'},
		{code: 'CW', name: 'CURAÇAO'},
		{code: 'DK', name: 'DANIMARCA'},
		{code: 'DM', name: 'DOMINICA'},
		{code: 'EC', name: 'ECUADOR'},
		{code: 'EG', name: 'EGITTO'},
		{code: 'SV', name: 'EL SALVADOR'},
		{code: 'AE', name: 'EMIRATI ARABI UNITI'},
		{code: 'ER', name: 'ERITREA'},
		{code: 'EE', name: 'ESTONIA'},
		{code: 'ET', name: 'ETIOPIA'},
		{code: 'FJ', name: 'FIGI'},
		{code: 'PH', name: 'FILIPPINE'},
		{code: 'FI', name: 'FINLANDIA'},
		{code: 'FR', name: 'FRANCIA'},
		{code: 'GA', name: 'GABON'},
		{code: 'GM', name: 'GAMBIA'},
		{code: 'GE', name: 'GEORGIA'},
		{code: 'GS', name: 'GEORGIA DEL SUD E ISOLE SANDWICH AUSTRALI'},
		{code: 'DE', name: 'GERMANIA'},
		{code: 'GH', name: 'GHANA'},
		{code: 'JM', name: 'GIAMAICA'},
		{code: 'JP', name: 'GIAPPONE'},
		{code: 'GI', name: 'GIBILTERRA'},
		{code: 'DJ', name: 'GIBUTI'},
		{code: 'JO', name: 'GIORDANIA'},
		{code: 'GR', name: 'GRECIA'},
		{code: 'GD', name: 'GRENADA'},
		{code: 'GL', name: 'GROENLANDIA'},
		{code: 'GP', name: 'GUADALUPA'},
		{code: 'GU', name: 'GUAM'},
		{code: 'GT', name: 'GUATEMALA'},
		{code: 'GG', name: 'GUERNSEY'},
		{code: 'GN', name: 'GUINEA'},
		{code: 'GW', name: 'GUINEA-BISSAU'},
		{code: 'GQ', name: 'GUINEA EQUATORIALE'},
		{code: 'GY', name: 'GUYANA'},
		{code: 'GF', name: 'GUYANA FRANCESE'},
		{code: 'HT', name: 'HAITI'},
		{code: 'HN', name: 'HONDURAS'},
		{code: 'HK', name: 'HONG KONG'},
		{code: 'IN', name: 'INDIA'},
		{code: 'ID', name: 'INDONESIA'},
		{code: 'IR', name: 'IRAN'},
		{code: 'IQ', name: 'IRAQ'},
		{code: 'IE', name: 'IRLANDA'},
		{code: 'IS', name: 'ISLANDA'},
		{code: 'BV', name: 'ISOLA BOUVET'},
		{code: 'IM', name: 'ISOLA DI MAN'},
		{code: 'CX', name: 'ISOLA DI NATALE'},
		{code: 'NF', name: 'ISOLA NORFOLK'},
		{code: 'AX', name: 'ISOLE ÅLAND'},
		{code: 'BQ', name: 'ISOLE BES'},
		{code: 'KY', name: 'ISOLE CAYMAN'},
		{code: 'CC', name: 'ISOLE COCOS (KEELING)'},
		{code: 'CK', name: 'ISOLE COOK'},
		{code: 'FO', name: 'FÆR ØER'},
		{code: 'FK', name: 'ISOLE FALKLAND'},
		{code: 'HM', name: 'ISOLE HEARD E MCDONALD'},
		{code: 'MP', name: 'ISOLE MARIANNE SETTENTRIONALI'},
		{code: 'MH', name: 'ISOLE MARSHALL'},
		{code: 'UM', name: 'ISOLE MINORI ESTERNE DEGLI STATI UNITI'},
		{code: 'PN', name: 'ISOLE PITCAIRN'},
		{code: 'SB', name: 'ISOLE SALOMONE'},
		{code: 'VG', name: 'ISOLE VERGINI BRITANNICHE'},
		{code: 'VI', name: 'ISOLE VERGINI AMERICANE'},
		{code: 'IL', name: 'ISRAELE'},
		{code: 'JE', name: 'JERSEY'},
		{code: 'KZ', name: 'KAZAKISTAN'},
		{code: 'KE', name: 'KENYA'},
		{code: 'KG', name: 'KIRGHIZISTAN'},
		{code: 'KI', name: 'KIRIBATI'},
		{code: 'KW', name: 'KUWAIT'},
		{code: 'LA', name: 'LAOS'},
		{code: 'LS', name: 'LESOTHO'},
		{code: 'LV', name: 'LETTONIA'},
		{code: 'LB', name: 'LIBANO'},
		{code: 'LR', name: 'LIBERIA'},
		{code: 'LY', name: 'LIBIA'},
		{code: 'LI', name: 'LIECHTENSTEIN'},
		{code: 'LT', name: 'LITUANIA'},
		{code: 'LU', name: 'LUSSEMBURGO'},
		{code: 'MO', name: 'MACAO'},
		{code: 'MK', name: 'MACEDONIA'},
		{code: 'MG', name: 'MADAGASCAR'},
		{code: 'MW', name: 'MALAWI'},
		{code: 'MY', name: 'MALESIA'},
		{code: 'MV', name: 'MALDIVE'},
		{code: 'ML', name: 'MALI'},
		{code: 'MT', name: 'MALTA'},
		{code: 'MA', name: 'MAROCCO'},
		{code: 'MQ', name: 'MARTINICA'},
		{code: 'MR', name: 'MAURITANIA'},
		{code: 'MU', name: 'MAURITIUS'},
		{code: 'YT', name: 'MAYOTTE'},
		{code: 'MX', name: 'MESSICO'},
		{code: 'FM', name: 'MICRONESIA'},
		{code: 'MD', name: 'MOLDAVIA'},
		{code: 'MN', name: 'MONGOLIA'},
		{code: 'ME', name: 'MONTENEGRO'},
		{code: 'MS', name: 'MONTSERRAT'},
		{code: 'MZ', name: 'MOZAMBICO'},
		{code: 'NA', name: 'NAMIBIA'},
		{code: 'NR', name: 'NAURU'},
		{code: 'NP', name: 'NEPAL'},
		{code: 'NI', name: 'NICARAGUA'},
		{code: 'NE', name: 'NIGER'},
		{code: 'NG', name: 'NIGERIA'},
		{code: 'NU', name: 'NIUE'},
		{code: 'NO', name: 'NORVEGIA'},
		{code: 'NC', name: 'NUOVA CALEDONIA'},
		{code: 'NZ', name: 'NUOVA ZELANDA'},
		{code: 'OM', name: 'OMAN'},
		{code: 'NL', name: 'PAESI BASSI'},
		{code: 'PK', name: 'PAKISTAN'},
		{code: 'PW', name: 'PALAU'},
		{code: 'PS', name: 'PALESTINA'},
		{code: 'PA', name: 'PANAMA'},
		{code: 'PG', name: 'PAPUA NUOVA GUINEA'},
		{code: 'PY', name: 'PARAGUAY'},
		{code: 'PE', name: 'PERÙ'},
		{code: 'PF', name: 'POLINESIA FRANCESE'},
		{code: 'PL', name: 'POLONIA'},
		{code: 'PR', name: 'PORTO RICO'},
		{code: 'PT', name: 'PORTOGALLO'},
		{code: 'MC', name: 'MONACO'},
		{code: 'QA', name: 'QATAR'},
		{code: 'GB', name: 'REGNO UNITO'},
		{code: 'CD', name: 'RD DEL CONGO'},
		{code: 'CZ', name: 'REP. CECA'},
		{code: 'CF', name: 'REP. CENTRAFRICANA'},
		{code: 'CG', name: 'REP. DEL CONGO'},
		{code: 'DO', name: 'REP. DOMINICANA'},
		{code: 'RE', name: 'RIUNIONE'},
		{code: 'RO', name: 'ROMANIA'},
		{code: 'RW', name: 'RUANDA'},
		{code: 'RU', name: 'RUSSIA'},
		{code: 'EH', name: 'SAHARA OCCIDENTALE'},
		{code: 'KN', name: 'SAINT KITTS E NEVIS'},
		{code: 'LC', name: 'SANTA LUCIA'},
		{code: 'SH', name: 'SANT\'ELENA, ASCENSIONE E TRISTAN DA CUNHA'},
		{code: 'VC', name: 'SAINT VINCENT E GRENADINE'},
		{code: 'BL', name: 'SAINT-BARTHÉLEMY'},
		{code: 'MF', name: 'SAINT-MARTIN'},
		{code: 'PM', name: 'SAINT-PIERRE E MIQUELON'},
		{code: 'WS', name: 'SAMOA'},
		{code: 'AS', name: 'SAMOA AMERICANE'},
		{code: 'SM', name: 'SAN MARINO'},
		{code: 'ST', name: 'SÃO TOMÉ E PRÍNCIPE'},
		{code: 'SN', name: 'SENEGAL'},
		{code: 'RS', name: 'SERBIA'},
		{code: 'SC', name: 'SEYCHELLES'},
		{code: 'SL', name: 'SIERRA LEONE'},
		{code: 'SG', name: 'SINGAPORE'},
		{code: 'SX', name: 'SINT MAARTEN'},
		{code: 'SY', name: 'SIRIA'},
		{code: 'SK', name: 'SLOVACCHIA'},
		{code: 'SI', name: 'SLOVENIA'},
		{code: 'SO', name: 'SOMALIA'},
		{code: 'ES', name: 'SPAGNA'},
		{code: 'LK', name: 'SRI LANKA'},
		{code: 'US', name: 'STATI UNITI'},
		{code: 'ZA', name: 'SUDAFRICA'},
		{code: 'SD', name: 'SUDAN'},
		{code: 'SS', name: 'SUDAN DEL SUD'},
		{code: 'SR', name: 'SURIname'},
		{code: 'SJ', name: 'SVALBARD E JAN MAYEN'},
		{code: 'SE', name: 'SVEZIA'},
		{code: 'CH', name: 'SVIZZERA'},
		{code: 'SZ', name: 'SWAZILAND'},
		{code: 'TW', name: 'TAIWAN'},
		{code: 'TJ', name: 'TAGIKISTAN'},
		{code: 'TZ', name: 'TANZANIA'},
		{code: 'TF', name: 'TERRE AUSTRALI E ANTARTICHE FRANCESI'},
		{code: 'IO', name: 'TERRITORIO BRITANNICO DELL\'OCEANO INDIANO'},
		{code: 'TH', name: 'THAILANDIA'},
		{code: 'TL', name: 'TIMOR EST'},
		{code: 'TG', name: 'TOGO'},
		{code: 'TK', name: 'TOKELAU'},
		{code: 'TO', name: 'TONGA'},
		{code: 'TT', name: 'TRINIDAD E TOBAGO'},
		{code: 'TN', name: 'TUNISIA'},
		{code: 'TR', name: 'TURCHIA'},
		{code: 'TM', name: 'TURKMENISTAN'},
		{code: 'TC', name: 'TURKS E CAICOS'},
		{code: 'TV', name: 'TUVALU'},
		{code: 'UA', name: 'UCRAINA'},
		{code: 'UG', name: 'UGANDA'},
		{code: 'HU', name: 'UNGHERIA'},
		{code: 'UY', name: 'URUGUAY'},
		{code: 'UZ', name: 'UZBEKISTAN'},
		{code: 'VU', name: 'VANUATU'},
		{code: 'VE', name: 'VENEZUELA'},
		{code: 'VN', name: 'VIETNAM'},
		{code: 'WF', name: 'WALLIS E FUTUNA'},
		{code: 'YE', name: 'YEMEN'},
		{code: 'ZM', name: 'ZAMBIA'},
		{code: 'ZW', name: 'ZIMBABWE'}
	];

	static countriesPrefixPhone = [
		{ code: '+39', name: 'Italia' },
		{ code: '+93', name: 'Afghanistan' },
		{ code: '+355', name: 'Albania' },
		{ code: '+213', name: 'Algeria' },
		{ code: '+1684', name: 'American Samoa' },
		{ code: '+376', name: 'Andorra' },
		{ code: '+244', name: 'Angola' },
		{ code: '+1264', name: 'Anguilla' },
		{ code: '+1268', name: 'Antigua & Barbuda' },
		{ code: '+599', name: 'Antille Olandesi' },
		{ code: '+966', name: 'Arabia Saudita' },
		{ code: '+54', name: 'Argentina' },
		{ code: '+374', name: 'Armenia' },
		{ code: '+37497', name: 'Armenia – Nagorno Karabakh' },
		{ code: '+297', name: 'Aruba' },
		{ code: '+247', name: 'Ascension' },
		{ code: '+61', name: 'Australia' },
		{ code: '+43', name: 'Austria' },
		{ code: '+994', name: 'Azerbaijan' },
		{ code: '+1242', name: 'Bahamas' },
		{ code: '+973', name: 'Bahrain' },
		{ code: '+880', name: 'Bangladesh' },
		{ code: '+1246', name: 'Barbados' },
		{ code: '+32', name: 'Belgio' },
		{ code: '+501', name: 'Belize' },
		{ code: '+229', name: 'Benin' },
		{ code: '+1441', name: 'Bermuda' },
		{ code: '+975', name: 'Bhutan' },
		{ code: '+375', name: 'Bielorussia' },
		{ code: '+591', name: 'Bolivia' },
		{ code: '+387', name: 'Bosnia Herzegovina' },
		{ code: '+267', name: 'Botswana' },
		{ code: '+55', name: 'Brasile' },
		{ code: '+673', name: 'Brunei' },
		{ code: '+359', name: 'Bulgaria' },
		{ code: '+226', name: 'Burkina Faso' },
		{ code: '+257', name: 'Burundi' },
		{ code: '+855', name: 'Cambogia' },
		{ code: '+237', name: 'Camerun' },
		{ code: '+1', name: 'Canada' },
		{ code: '+238', name: 'Capo Verde' },
		{ code: '+1345', name: 'Cayman Islands' },
		{ code: '+235', name: 'Ciad' },
		{ code: '+56', name: 'Cile' },
		{ code: '+86', name: 'Cina' },
		{ code: '+357', name: 'Cipro' },
		{ code: '+57', name: 'Colombia' },
		{ code: '+242', name: 'Congo' },
		{ code: '+243', name: 'Congo (Rep. Democratica)' },
		{ code: '+682', name: 'Cook Islands' },
		{ code: '+850', name: 'Corea del Nord' },
		{ code: '+82', name: 'Corea del Sud' },
		{ code: '+225', name: 'Costa d’Avorio' },
		{ code: '+506', name: 'Costa Rica' },
		{ code: '+385', name: 'Croazia' },
		{ code: '+53', name: 'Cuba' },
		{ code: '+45', name: 'Danimarca' },
		{ code: '+246', name: 'Diego Garcia' },
		{ code: '+1767', name: 'Dominica' },
		{ code: '+593', name: 'Ecuador' },
		{ code: '+20', name: 'Egitto' },
		{ code: '+503', name: 'El Salvador' },
		{ code: '+971', name: 'Emirati Arabi Uniti' },
		{ code: '+291', name: 'Eritrea' },
		{ code: '+372', name: 'Estonia' },
		{ code: '+251', name: 'Etiopia' },
		{ code: '+500', name: 'Falkland Islands' },
		{ code: '+298', name: 'Faroe Islands' },
		{ code: '+63', name: 'Filippine' },
		{ code: '+679', name: 'Fiji' },
		{ code: '+358', name: 'Finlandia' },
		{ code: '+33', name: 'Francia' },
		{ code: '+241', name: 'Gabon' },
		{ code: '+220', name: 'Gambia' },
		{ code: '+995', name: 'Georgia' },
		{ code: '+49', name: 'Germania' },
		{ code: '+233', name: 'Ghana' },
		{ code: '+1876', name: 'Giamaica' },
		{ code: '+81', name: 'Giappone' },
		{ code: '+350', name: 'Gibilterra' },
		{ code: '+253', name: 'Gibuti (Rep. del Djibouti)' },
		{ code: '+962', name: 'Giordania' },
		{ code: '+30', name: 'Grecia' },
		{ code: '+299', name: 'Groenlandia' },
		{ code: '+1473', name: 'Grenada' },
		{ code: '+590', name: 'Guadalupa' },
		{ code: '+1671', name: 'Guam' },
		{ code: '+502', name: 'Guatemala' },
		{ code: '+224', name: 'Guinea' },
		{ code: '+245', name: 'Guinea Bissau' },
		{ code: '+240', name: 'Guinea Equatoriale' },
		{ code: '+592', name: 'Guyana' },
		{ code: '+594', name: 'Guyana Francese' },
		{ code: '+509', name: 'Haiti' },
		{ code: '+504', name: 'Honduras' },
		{ code: '+852', name: 'Hong Kong' },
		{ code: '+91', name: 'India' },
		{ code: '+62', name: 'Indonesia' },
		{ code: '+98', name: 'Iran' },
		{ code: '+964', name: 'Iraq' },
		{ code: '+353', name: 'Irlanda' },
		{ code: '+354', name: 'Islanda' },
		{ code: '+44', name: 'Isola di Jersey' },
		{ code: '+44', name: 'Isola di Guernsey' },
		{ code: '+44', name: 'Isola di Man' },
		{ code: '+1284', name: 'Isole Vergini Britanniche' },
		{ code: '+1340', name: 'Isole Vergini (US)' },
		{ code: '+972', name: 'Israele' },
		{ code: '+7', name: 'Kazakhstan' },
		{ code: '+254', name: 'Kenya' },
		{ code: '+686', name: 'Kiribati' },
		{ code: '+383', name: 'Kosovo' },
		{ code: '+965', name: 'Kuwait' },
		{ code: '+996', name: 'Kyrgyzstan' },
		{ code: '+856', name: 'Laos' },
		{ code: '+266', name: 'Lesotho' },
		{ code: '+371', name: 'Lettonia (Latvia)' },
		{ code: '+961', name: 'Libano' },
		{ code: '+231', name: 'Liberia' },
		{ code: '+218', name: 'Libia' },
		{ code: '+423', name: 'Liechtenstein' },
		{ code: '+370', name: 'Lituania' },
		{ code: '+352', name: 'Lussemburgo' },
		{ code: '+853', name: 'Macao' },
		{ code: '+389', name: 'Macedonia' },
		{ code: '+261', name: 'Madagascar' },
		{ code: '+265', name: 'Malawi' },
		{ code: '+60', name: 'Malesia' },
		{ code: '+960', name: 'Maldive' },
		{ code: '+223', name: 'Mali' },
		{ code: '+356', name: 'Malta' },
		{ code: '+212', name: 'Marocco' },
		{ code: '+692', name: 'Marshall Islands' },
		{ code: '+596', name: 'Martinica' },
		{ code: '+222', name: 'Mauritania' },
		{ code: '+230', name: 'Mauritius' },
		{ code: '+269', name: 'Mayotte - Comores' },
		{ code: '+52', name: 'Messico' },
		{ code: '+691', name: 'Micronesia' },
		{ code: '+373', name: 'Moldova' },
		{ code: '+377', name: 'Monaco' },
		{ code: '+976', name: 'Mongolia' },
		{ code: '+1664', name: 'Montserrat' },
		{ code: '+382', name: 'Montenegro' },
		{ code: '+258', name: 'Mozambico' },
		{ code: '+95', name: 'Myanmar' },
		{ code: '+264', name: 'Namibia' },
		{ code: '+674', name: 'Nauru' },
		{ code: '+977', name: 'Nepal' },
		{ code: '+505', name: 'Nicaragua' },
		{ code: '+227', name: 'Niger' },
		{ code: '+234', name: 'Nigeria' },
		{ code: '+683', name: 'Niue' },
		{ code: '+672', name: 'Norfolk Island' },
		{ code: '+1670', name: 'Northern Mariana Islands' },
		{ code: '+47', name: 'Norvegia' },
		{ code: '+687', name: 'Nuova Caledonia' },
		{ code: '+64', name: 'Nuova Zelanda' },
		{ code: '+968', name: 'Oman' },
		{ code: '+31', name: 'Paesi Bassi (Olanda)' },
		{ code: '+92', name: 'Pakistan' },
		{ code: '+680', name: 'Palau' },
		{ code: '+972', name: 'Palestina' },
		{ code: '+507', name: 'Panama' },
		{ code: '+675', name: 'Papua Nuova Guinea' },
		{ code: '+595', name: 'Paraguay' },
		{ code: '+51', name: 'Perù' },
		{ code: '+689', name: 'Polinesia Francese' },
		{ code: '+48', name: 'Polonia' },
		{ code: '+351', name: 'Portogallo' },
		{ code: '+1787', name: 'Porto Rico' },
		{ code: '+974', name: 'Qatar' },
		{ code: '+44', name: 'Regno Unito' },
		{ code: '+420', name: 'Repubblica Ceca' },
		{ code: '+236', name: 'Repubblica Centro Africana' },
		{ code: '+1809', name: 'Repubblica Dominicana 1' },
		{ code: '+1829', name: 'Repubblica Dominicana 2' },
		{ code: '+421', name: 'Repubblica Slovacca' },
		{ code: '+262', name: 'Reunion' },
		{ code: '+40', name: 'Romania' },
		{ code: '+250', name: 'Ruanda' },
		{ code: '+7', name: 'Russia' },
		{ code: '+684', name: 'Samoa (American Samoa)' },
		{ code: '+1684', name: 'Samoa (American Samoa)' },
		{ code: '+685', name: 'Samoa (Western Samoa)' },
		{ code: '+290', name: 'St. Helena' },
		{ code: '+1869', name: 'St. Kitts & Nevis' },
		{ code: '+1758', name: 'St. Lucia' },
		{ code: '+508', name: 'St. Pierre & Miquelon' },
		{ code: '+1784', name: 'St. Vincent & Grenadines' },
		{ code: '+378', name: 'San Marino' },
		{ code: '+239', name: 'Sao Tome & Principe' },
		{ code: '+221', name: 'Senegal' },
		{ code: '+381', name: 'Serbia' },
		{ code: '+248', name: 'Seychelles' },
		{ code: '+232', name: 'Sierra Leone' },
		{ code: '+65', name: 'Singapore' },
		{ code: '+963', name: 'Siria' },
		{ code: '+386', name: 'Slovenia' },
		{ code: '+677', name: 'Solomon Islands' },
		{ code: '+252', name: 'Somalia' },
		{ code: '+27', name: 'Sud Africa' },
		{ code: '+34', name: 'Spagna' },
		{ code: '+94', name: 'Sri Lanka' },
		{ code: '+249', name: 'Sudan' },
		{ code: '+597', name: 'Suriname' },
		{ code: '+46', name: 'Svezia' },
		{ code: '+41', name: 'Svizzera' },
		{ code: '+268', name: 'Swaziland' },
		{ code: '+886', name: 'Taiwan' },
		{ code: '+992', name: 'Tajikistan' },
		{ code: '+66', name: 'Tailandia' },
		{ code: '+255', name: 'Tanzania' },
		{ code: '+670', name: 'Timor East' },
		{ code: '+228', name: 'Togo' },
		{ code: '+690', name: 'Tokelau' },
		{ code: '+676', name: 'Tonga' },
		{ code: '+1868', name: 'Trinidad & Tobago' },
		{ code: '+216', name: 'Tunisia' },
		{ code: '+90', name: 'Turchia' },
		{ code: '+993', name: 'Turkmenistan' },
		{ code: '+1649', name: 'Turks & Caicos Islands' },
		{ code: '+688', name: 'Tuvalu' },
		{ code: '+380', name: 'Ucraina' },
		{ code: '+256', name: 'Uganda' },
		{ code: '+36', name: 'Ungheria' },
		{ code: '+598', name: 'Uruguay' },
		{ code: '+1', name: 'Usa' },
		{ code: '+998', name: 'Uzbekistan' },
		{ code: '+678', name: 'Vanuatu' },
		{ code: '+379', name: 'Vaticano 2' },
		{ code: '+58', name: 'Venezuela' },
		{ code: '+84', name: 'Vietnam' },
		{ code: '+681', name: 'Wallis and Futuna' },
		{ code: '+685', name: 'Western Samoa' },
		{ code: '+967', name: 'Yemen' },
		{ code: '+260', name: 'Zambia' },
		{ code: '+263', name: 'Zimbabwe' }
		];

	static getCountryName(code: string): string {
		const filter = CountriesListModel.countries.filter(value => value.code.toLowerCase() === code.toLowerCase());
		return filter.length === 1 ? filter[0].name : '';
	}

	static getCountryCode(name: string): string {
		const filter = CountriesListModel.countries.filter(value => value.name.toLowerCase() === name.toLowerCase());
		return filter.length === 1 ? filter[0].code : '';
	}

	static getIsoCountryName(code: string): string {
		if (!Utilities.isVoid(code)) {
			const filter = CountriesListModel.isoCountries.filter(value => value.code.toLowerCase() === code.toLowerCase());
			return filter.length === 1 ? filter[0].name : '';
		}
		return '';
	}

	static getIsoCountryCode(name: string): string {
		if (!Utilities.isVoid(name)) {
			const filter = CountriesListModel.isoCountries.filter(value => value.name.toLowerCase() === name.toLowerCase());
			return filter.length === 1 ? filter[0].code : '';
		}
		return ''
	}
}
